import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonsService } from 'src/app/services/commons.service';

@Component({
  standalone: false,
  selector: 'app-engagement',
  templateUrl: './engagement.component.html',
  styleUrls: ['./engagement.component.scss']
})
export class EngagementComponent implements OnInit {
  country: string;
  language: string;
  constructor(private route: Router, private commonService: CommonsService) { }

  params = [];
  data: any;
  show = false;
  showError = false;
  addDocumentation = false;
  isRapidScore = false;
  headerFooter = false

  ngOnInit() {
    const v = JSON.parse(sessionStorage.getItem('getParams'));
    this.language = sessionStorage.getItem('language');
    this.country = sessionStorage.getItem('country') || 'ES';
    if (v) {

      this.headerFooter = v[0] !== '3';
    } else {
      this.headerFooter = true;
    }
    this.isRapidScore = !!JSON.parse(sessionStorage.getItem('getParams'));
    if (sessionStorage.getItem('_k_engagement')) {
      this.data = this.commonService.decrypt(sessionStorage.getItem('_k_engagement'));
    } else {
      this.data = this.commonService.decrypt(sessionStorage.getItem('_k'));
    }
  }

  saveUrl() {
    this.commonService.setCurrentUrl(this.route.url);
    this.route.navigateByUrl('faqs');
  }


  /**
   * TODO: recoger parametros URL
   */
  getParamsURL() {
    const url = window.location.href;
    if (url.includes('v1') || url.includes('v2') || url.includes('v3')) {
      let aux = url.split('?v1=')[1];
      this.params.push(aux.substr(0, aux.indexOf('&v2')));
      aux = url.split('&v2=')[1];
      this.params.push(aux.substr(0, aux.indexOf('&v3=')));
      aux = url.split('&v3=')[1];
      this.params.push(aux.substr(0, aux.length));
      sessionStorage.setItem('getParams', JSON.stringify(this.params));
    }
  }
}
